import React from 'react'

import { Route } from 'react-router'

import { client } from 'config/routes'
import { MainLayout } from 'layouts/MainLayout'

import { PrivacyPolicy } from './PrivacyPolicy'

export const route = (
  <Route component={MainLayout}>
    <Route path={client.privacyPolicy} component={PrivacyPolicy} />
  </Route>
)
